import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {User} from '../model/user';
import {ProjectService} from '../project/project.service';
import {AuthenticationService} from '../login/authentication.service';

@Component(
  {
    moduleId: module.id,
    template: `
      <nav class="navbar navbar-expand-sm navbar-dark bg-dark">
        <a class="navbar-brand" href="#">
          <img src="https://getbootstrap.com/docs/4.3/assets/brand/bootstrap-solid.svg" width="30" height="30" class="d-inline-block align-top" alt="">
          JuJu
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
              <a class="nav-link" [routerLink]="'/login'" style="color: #00b0ff">Home <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item" style="border-style: dashed;border-color: white;border-width: 1px;">
              <a class="nav-link" [routerLink]="'/register'" style="color: #00b0ff">Register</a>
            </li>
          </ul>
          <form class="form-inline my-2 my-lg-0">
            <button type="button"  style="margin-right: 10px;" class="btn btn-outline-primary my-2 my-sm-0" *ngFor="let lang of supportedLanguages">
              <a (click)="selectLang(lang.value)"><span class="flag-icon flag-icon-{{lang.value==='en'?'us':'fr'}}"> </span></a>
            </button>
          </form>
        </div>
      </nav>
      <div class="w3-card-4" style="margin-top: 5%;margin-left: 40%;width:23%;">
        <div class="card-header" style="background-color:dodgerblue">
          <img style="height:60px;margin-top:-10px;" class="mailWindow" src="../../assets/images/userManagement.png">
          <span style="color:antiquewhite;margin-left:10px;font-size: 20px;margin-top:15px;">New User</span>
        </div>
        <div class="card-body">
          <p class="card-title">Enter Details ...</p>
          <div><img alt="logo" src="../../assets/images/nl-icon.png"></div>
          <form name="newUserForm" (ngSubmit)="f.valid && registerNewMember()" #f="ngForm" class="regForm">
            <div class="form-group">
              <input type="email" name="username" [(ngModel)]="user.Username" #username="ngModel" class="form-control" autocomplete="off" [className]="validate(user.Username,true)" autofocus id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="eg:adam@nomadlogic.com"
                     pattern="\\w+@\\w+.\\w{2,3}">
              <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
            </div>
            <div class="form-group">
              <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password" autocomplete="off" name="password" [className]="validate(user.Password,false)" [(ngModel)]="user.Password" #password="ngModel" required [maxLength]="10" [minLength]="8"
                     pattern="\\w*\\W*">
              <div *ngIf="password.errors && (password.dirty || password.touched)"
                   class="alert alert-danger">
                <div [hidden]="!password.errors.required">
                  Password is required
                </div>
                <div [hidden]="!password.errors.maxlength">
                  Password must be at most 10 characters long.
                </div>
                <div [hidden]="!password.errors.minlength">
                  Password must be at least 8 characters long.
                </div>
                <div [hidden]="!password.errors.pattern">
                  Password must contain at least one none word character.
                </div>
              </div>
            </div>
            <div class="form-group">
              <ngx-select
                  [allowClear]="false"
                  [placeholder] =  "this.roles[0]"
                  [items]="this.roles"
                  (select)="onRoleChange($event)">
              </ngx-select>
              <div *ngIf="this.user.Role == -1" class="alert alert-danger">
                <div>
                  You must select a role
                </div>
              </div>
            </div>
            <button type="submit" class="btn btn-primary">Submit</button>
          </form>
        </div>
        <footer class="w3-container w3-black">
          <h5>JuJu</h5>
        </footer>
      </div>
      <generic-info-modal [hide]="_hideInfoModal" [title]="_modalTitle" [text]="_genericModalText"
                          (OkClick)="onOk()" [statusCode]="_statusCode"></generic-info-modal>
    `,
    styleUrls:[`../../assets/css/registerFormStyle.css`]
  })

export class RegisterComponent implements OnInit, OnDestroy {
  private newUserForm:FormGroup;
  private user:User;
  private supportedLanguages:any[];

  private _modalTitle = 'User Management';
  private _hideInfoModal = true;
  private _genericModalText = '';
  private _statusCode = 200;

  private roles = ['Select a User Role','Admin','Regular'];

  constructor(private projectService:ProjectService, private _authenticationService: AuthenticationService,) {
    this.user = new User(-1,'');
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.newUserForm = new FormGroup({
      'username':new FormControl(this.user.Username,[Validators.required]),
      'password':new FormControl(this.user.Password,[Validators.required,Validators.maxLength(10),Validators.minLength(8),Validators.pattern('\W*')]),
      'role':new FormControl(this.user.Role,[Validators.required])
    });

    this.supportedLanguages = [
      { display: 'English', value: 'en' },
      { display: 'Français', value: 'fr' }
    ];

  }

  onRoleChange(role:any) {
    console.log(role);
    switch (role) {
      case 'Admin':this.user.Role = 1; break;
      case 'Regular' :  this.user.Role= 2; break;
      default: this.user.Role = -1;
    }
  }

   registerNewMember() {
        /*const user = new User(2,this.newUserForm['controls'].username.value);
        user.password = this.newUserForm['controls'].password.value;*/
        this.projectService.createUser(this.user).subscribe((msg)=> {

          if(msg === 100) {
            this._genericModalText = 'You have successfully created a new account!';
            this._hideInfoModal = false;
          } else {
            this._genericModalText = 'An error has occurred while creating a your account!';
            this._hideInfoModal = false;
          }
        });
        this.newUserForm.reset();
  }

  selectLang(lang: string) {
    // console.log(lang);
    // set default;
    localStorage.setItem('language', lang);

  }

  onOk() {

    this._hideInfoModal = true;
  }

  validate(val: string,email:boolean):string {
    if (email) {
      const regexp = new RegExp('\\w+@\\w+.\\w{2,3}');

      const rep = regexp.test(val);
      return 'form-control validated';
    }
    return 'form-control validated';
  }
}
